class ShopScript {
	constructor(el, opt) {
		this.el = el;
		if($(this.el).length){
			this.event();
		}
	}

	event(){
    let options = {
      threshold: [0.5]
    }
		if($('.s-bliss').length) {
			const observerEnter = new IntersectionObserver(entries => {
				entries.forEach(entry => {
					if(entry.intersectionRatio > 0.5) {
						$('.js-hdr-typ').removeClass('active');
					} else {
						$('.js-hdr-typ').addClass('active');
					}
				});
			}, options);

			let el = document.querySelectorAll('.s-mv-typ05, .mv-img');
			el.forEach(element => {
				observerEnter.observe(element);
			});
		}
		$(".js-hdr-drawer, .c-drawer01 .nav a").on('click', function(){
			$(".js-hdr-typ").toggleClass('is-active');
		})
		if($(".mySwiper").hasClass('s-member-type01__listWrap')) {
			if($('.mySwiper .swiper-slide').length <= 4) {
				$('html').addClass('member-few');
			}
			var swiper = new Swiper(".mySwiper", {
				// autoplay: {
				// 	disableOnInteraction: false,
				// 	delay: 4000,
				// },
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				speed: 1000,
				slidesPerView: 1.5,
				spaceBetween: 20,
				centeredSlides : true,
				loop: true,
				breakpoints: {
					960: {
						navigation: {
							nextEl: ".swiper-button-next",
							prevEl: ".swiper-button-prev",
						},
						loop: false,
						slidesPerView: 4,
						spaceBetween: 50,
						centeredSlides : false,
					}
				}
			});
		} else if($(".mySwiper").hasClass('s-member-type02__listWrap') && window.matchMedia( "(max-width: 980px)" ).matches) {
			var swiper = new Swiper(".mySwiper", {
				autoplay: {
					disableOnInteraction: false,
					delay: 4000,
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				speed: 1000,
				slidesPerView: 1.4,
				spaceBetween: 20,
				centeredSlides : true,
				loop: true,
				breakpoints: {
					960: {
						slidesPerView: 4,
						spaceBetween: 50,
						centeredSlides : false,
					}
				}
			});
		}

		if($(".mySwiper").hasClass('s-member-type03__listWrap') && window.matchMedia( "(max-width: 980px)" ).matches) {
			var swiper = new Swiper(".mySwiper", {
				// autoplay: {
				// 	disableOnInteraction: false,
				// 	delay: 4000,
				// },
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				speed: 1500,
				slidesPerView: 1,
				spaceBetween: 20,
				centeredSlides : false,
				breakpoints: {
					960: {
						slidesPerView: 1,
						spaceBetween: 20,
						centeredSlides : true,
					}
				}
			});
		}

		var swiper_modal;

		$('.js-modal-trigger').on("click", function() {
			if($(`${$(this).attr('href')}`).length) {
				$(`${$(this).attr('href')}`).addClass('is-active');
				$("body").css({overflow: 'hidden'});

				if(`${$(this).attr('href')} .modal-swiper`.length) {
					swiper = new Swiper(`${$(this).attr('href')} .modal-swiper`, {
						slidesPerView: 1,
						speed: 500,
						centeredSlides : true,
						navigation: {
							nextEl: ".swiper-button-next",
							prevEl: ".swiper-button-prev",
						},
					});
					return false;
				}
			}
		})

		$('.js-overlay, .js-close').on('click', function() {
			$('.s-hair-type01__modal, .s-member-type01-modal, .s-member-modal, .s-staff-type01-modal').removeClass('is-active');
			$("body").css({overflow: 'inherit'});
			setTimeout(function() {
        swiper.destroy(false, true);
      }, 400)
		})

		$('.js-menu-tab li').on('click', function() {
			$('.js-menu-tab li').removeClass('is-active');
			$(this).addClass('is-active');
			$('.js-menu-inner').removeClass('is-active').css({'display': 'none'}).eq($(this).index()).fadeToggle();
		})

		if($(".s-hair-type02, .s-hair-type03").length) {
			new Swiper(".hair-swiper", {
				autoplay: {
					disableOnInteraction: false,
					delay: 4000,
				},
				slidesPerView: 1.3,
				spaceBetween: 10,
				loop: true,
				speed: 1000,
				centeredSlides : true,
				// navigation: {
				// 	nextEl: ".swiper-button-hair-next",
				// 	prevEl: ".swiper-button-hair-prev",
				// },
				breakpoints: {
					960: {
						centeredSlides : false,
						slidesPerView: 4,
						spaceBetween: 30,
						centeredSlides : false,
					}
				}
			});
		}

		if($(".c-hdr-typ04").length) {

			const w_ele = document.querySelector('.s-mv-typ04');

			const options = {
				threshold: 0
			};

			const observer = new IntersectionObserver(function(e) {
				if(!e[0].intersectionRatio > 0) {
					$(".c-hdr-typ04").addClass('is-scroll');
				} else {
					$(".c-hdr-typ04").removeClass('is-scroll');
				}
			}, options);

			observer.observe(w_ele);
		}

		if($(".c-hdr-typ05").length) {

			const w_ele = document.querySelector('.s-mv-typ05');
			const t_ele = document.querySelector('.s-contact-type05');

			const options = {
				threshold: 0
			};

			const observer = new IntersectionObserver(function(e) {
				if(!e[0].intersectionRatio > 0) {
					$(".c-hdr-typ05").addClass('is-scroll');
				} else {
					$(".c-hdr-typ05").removeClass('is-scroll');
				}
			}, options);

			const observer02 = new IntersectionObserver(function(e) {
				if(!e[0].intersectionRatio > 0) {
					$(".c-hdr-typ05").removeClass('is-footer');
				} else {
					$(".c-hdr-typ05").addClass('is-footer');
				}
			}, options);

			observer.observe(w_ele);
			observer02.observe(t_ele);
		}
	}
}


